import { Field, ID, InputType } from 'type-graphql'
import type { Task } from '../../task/Task'
import { ActionArgs } from '../../action/ActionArgs'
import type { WorkOrder } from '../WorkOrder'
import type { IAction } from '../../action/IAction'
import GraphQLJSON from 'graphql-type-json'

@InputType()
export class UpdateWorkOrderTaskArgs extends ActionArgs {
  @Field(() => GraphQLJSON)
  taskInput: Task

  @Field(() => ID)
  workOrderId: string
}

export interface IUpdateWorkOrderTask extends IAction<WorkOrder, UpdateWorkOrderTaskArgs> {}
